import Parse from 'parse/dist/parse.min.js';
import { handleParseError } from '../../lib/Errors';

let localSubscription = undefined;

function createSubscription(store) {
	let dataQuery = new Parse.Query('MedicationInstantMedication');
	dataQuery.notEqualTo("deleted", true)
	dataQuery.include(["medication", "medication.medicationForm", "medication.medicationUnit", "user", "user.dependency"])
	dataQuery.find()
		.then((results) => {
			store.dispatch('instant_medication/set', results)
		})
		.catch((error) => {
			handleParseError(error);
			
		});
		dataQuery.subscribe().then((subscription) => {
		
		localSubscription = subscription;

		subscription.on('create', object => {
			
			store.dispatch('instant_medication/insert', object)
		});
		subscription.on('update', object => {
			
			store.dispatch('instant_medication/replace', object)
		});
		subscription.on('enter', object => {
			
			store.dispatch('instant_medication/insert', object)
		});
		subscription.on('leave', object => {
			
			store.dispatch('instant_medication/delete', object)
		});
		subscription.on('delete', object => {
			
			store.dispatch('instant_medication/delete', object)
		});
		subscription.on('close', () => {
		});
		subscription.on('error', error => {
            console.log('InstantMedication subscription error', error);
        })
	})
}

export default function createInstantMedicationSubscription() {
	return store => {
		if (store.state.currentUser) {
			createSubscription(store)
		}
		store.subscribe(mutation => {
			if (mutation.type === 'SET_CURRENT_USER') {
				if (localSubscription) {
					localSubscription.unsubscribe()
				}
				if (store.state.currentUser) {
					createSubscription(store)
				}
			}
		})
	}
}
